<template>
    <div>
        <login />
    </div>
</template>
<script>
import Login from '@/views/Login'
export default {
    components: {
        Login
    },
    mounted(){
        //document.querySelector('body').style.overflowY = 'hidden'
    }
}
</script>
<style>
</style>
